<template>
  <div class="dashboard_warp">
    <!-- <div class="user-top">
      <span>会员总数:{{newUsers}}</span>
      <div class="user-view" id="userChart"></div>
      <div class="center">
        <span>每日新增用户</span>
      </div>
    </div>

    <div class="user-top" style="margin-top:20px;height:400px;">
      <div class="order-top">
        <div class="order-list" v-for="(item,index) in orderList" :key="index" @click="onOrder(index)">
          <span :style="{color:index == curOrder ? '#587bf3' : '#333'}">{{item}}</span>
          <div class="line" v-if="index == curOrder"></div>
        </div>
      </div>
      <span style="margin-top:10px" v-if="orderData"> {{curOrder == 0 ? `订单总数:${orderData.totalCount}` : `订单总金额:${orderData.totalAmount}`}}</span>
      <div class="user-view" id="orderChart"></div>
      <div class="center">
        <span>{{curOrder == 0 ? '每日新增订定数量' : '每日新增订定金额'}}</span>
      </div>
    </div>

    <div class="user-top" style="margin-top:20px;height:750px;">
      <div class="order-top">
        <div class="order-list" v-for="(item,index) in bottomList" :key="index" @click="onBottom(index)">
          <span :style="{color:index == curBottom ? '#587bf3' : '#333'}">{{item}}</span>
          <div class="line" v-if="index == curBottom"></div>
        </div>
      </div>
      <span style="margin-top:10px" v-if="bottomData">{{curBottomTop}}:{{curValue}} </span>
      <div class="user-view" id="bottomChart"></div>
      <div class="center">
        <span>{{curBottomBom}}</span>
      </div>
      <div class="user-view" id="bottomChartOne"></div>
      <div class="center">
        <span>{{curBottomBomTwo}}</span>
      </div>
    </div> -->

  </div>
</template>

<script>
import defaultSettings from "@/settings";
import echarts from "echarts";
import {
  getUsersStatis,
  getOrderStatis,
  getBalanceStatis,
} from "@/api/dashboard";
import { isPositiveNegativeOrZero } from "@/utils/index";

export default {
  name: "Dashboard",
  data() {
    return {
      newUsers:'',
      userChart:null,
      orderChart:null,
      orderList:['订单数量','订单金额'],
      curOrder:0,
      orderData:null,
      bottomList:['贡献值','现金金额','抽奖次数','兑换券','数字积分(TBC)'],
      curBottom:0,
      bottomData:null,
      bottomChart:null,
      bottomChartOne:null,
      curBottomBomTwo:'',
      curBottomTop:'',
      curBottomBom:'',
      curValue:'',
    };
  },
  created() {
    let _this = this;
    window.addEventListener('resize',function(){
      if(_this.userChart){
        _this.userChart.resize();
      }
      if(_this.orderChart){
        _this.orderChart.resize();
      }
      if(_this.bottomChart){
        _this.bottomChart.resize();
      }
      if(_this.bottomChartOne){
        _this.bottomChartOne.resize();
      }
      
    })
    this.usersStatis();
    this.orderStatis();
    this.balanceStatis();
  },
  beforeDestroy() {
    if (this.userChart) {
      this.userChart.dispose()
      this.userChart = null;
    }
    if (this.orderChart) {
      this.orderChart.dispose()
      this.orderChart = null;
    }
    if (this.bottomChart) {
      this.bottomChart.dispose()
      this.bottomChart = null;
    }
    if (this.bottomChartOne) {
      this.bottomChartOne.dispose()
      this.bottomChartOne = null;
    }
    
  },
  methods: {
    balanceStatis(){
      getBalanceStatis().then(res=>{
        this.bottomData = res.data;
        this.curBottomTop = '总贡献值';
          this.curBottomBom = '每日新增贡献值';
          this.curBottomBomTwo = '每日消耗贡献值';
          this.curValue = this.bottomData.filter(i=>i.category == 'expend')[0].curAmount;
        this.initBottomCharts();
      })
    },
    usersStatis(){
      getUsersStatis().then(res=>{
        this.newUsers = res.data.totalCount;
        this.initUserCharts(res.data.dailys);
      })
    },
    orderStatis(){
      getOrderStatis().then(res=>{
        this.orderData = res.data;
        this.initOrderCharts();
      })
    },
    onOrder(index){
      if(index != this.curOrder){
        this.curOrder = index;
        this.initOrderCharts(true);
      }
    },
    onBottom(index){
      if(index != this.curBottom){
        this.curBottom = index;
        if(index == 0){
           this.curBottomTop = '总贡献值';
           this.curBottomBom = '每日新增贡献值';
          this.curBottomBomTwo = '每日消耗贡献值';
           this.curValue = this.bottomData.filter(i=>i.category == 'expend')[0].curAmount;
        }else if(index == 1){
          this.curBottomTop = '总现金金额';
          this.curBottomBom = '每日新增现金金额';
          this.curBottomBomTwo = '每日消耗现金金额';
           this.curValue = this.bottomData.filter(i=>i.category == 'balance')[0].curAmount;
        }else if(index == 2){
          this.curBottomTop = '总抽奖次数';
          this.curBottomBom = '每日新增抽奖次数';
          this.curBottomBomTwo = '每日消耗抽奖次数';
          this.curValue = this.bottomData.filter(i=>i.category == 'raffle')[0].curAmount;
        }else if(index == 3){
          this.curBottomTop = '总兑换券';
          this.curBottomBom = '每日新增兑换券';
          this.curBottomBomTwo = '每日消耗兑换券';
          this.curValue = this.bottomData.filter(i=>i.category == 'redpacket')[0].curAmount;
        }else if(index == 4){
          this.curBottomTop = '总数字积分(TBC)';
          this.curBottomBom = '每日新增数字积分(TBC)';
          this.curBottomBomTwo = '每日消耗数字积分(TBC)';
          this.curValue = this.bottomData.filter(i=>i.category == 'vcoin')[0].curAmount;
        }
        this.initBottomCharts(true);
      }
    },
    initBottomCharts(type = false){
      if(!type){
        let chartDom = document.getElementById('bottomChart');
        let chartDomTwo = document.getElementById('bottomChartOne');
        this.bottomChart = echarts.init(chartDom);
        this.bottomChartOne = echarts.init(chartDomTwo);
      }
      
      let arr = [];
      let time = [];
      let data = null;
      let dataTwo = null;
      let arrTwo = [];
      let timeTwo = [];
      if(this.curBottom == 0){
        data = this.bottomData.filter(i=>i.category == 'expend')[0].addDailyList;
        dataTwo = this.bottomData.filter(i=>i.category == 'expend')[0].reduceDailyList;
      }else if(this.curBottom == 1){
        data = this.bottomData.filter(i=>i.category == 'balance')[0].addDailyList;
        dataTwo = this.bottomData.filter(i=>i.category == 'balance')[0].reduceDailyList;
      }else if(this.curBottom == 2){
        data = this.bottomData.filter(i=>i.category == 'raffle')[0].addDailyList;
        dataTwo = this.bottomData.filter(i=>i.category == 'raffle')[0].reduceDailyList;
      }else if(this.curBottom == 3){
        data = this.bottomData.filter(i=>i.category == 'redpacket')[0].addDailyList;
        dataTwo = this.bottomData.filter(i=>i.category == 'redpacket')[0].reduceDailyList;
      }else if(this.curBottom == 4){
        data = this.bottomData.filter(i=>i.category == 'vcoin')[0].addDailyList;
        dataTwo = this.bottomData.filter(i=>i.category == 'vcoin')[0].reduceDailyList;
      }
      if(dataTwo ){
        dataTwo.forEach(item=>{
          arrTwo.push(item.dailyAmount);
          timeTwo.push(item.date);
        })
      }
       if(data){
       data.forEach(item=>{
        arr.push(item.dailyAmount);
        time.push(item.date);
      })
      }
      

      let option;
      let optionOne;

      option = {
        xAxis: {
          type: 'category',
          data: time
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: arr,
            smooth:true,
            type: 'line',
            itemStyle:{
              color:'#587bf3'
            }
          }
        ],
         tooltip:{trigger:'axis',axisPointer:{type:'line'}}
      };

      optionOne = {
        xAxis: {
          type: 'category',
          data: timeTwo
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: arrTwo,
            smooth:true,
            type: 'line',
            itemStyle:{
              color:'#587bf3'
            }
          }
        ],
         tooltip:{trigger:'axis',axisPointer:{type:'line'}}
      };

      option && this.bottomChart.setOption(option);
      optionOne && this.bottomChartOne.setOption(optionOne);
    },
    initOrderCharts(type = false){
      if(!type){
        let chartDom = document.getElementById('orderChart');
        this.orderChart = echarts.init(chartDom);
      }
      
      let arr = [];
      let time = [];
      this.orderData.dailys.forEach(item=>{
        if(this.curOrder == 0){
          arr.push(item.dailyOrderCount);
        }else{
          arr.push(item.dailyOrderAmount);
        }
        time.push(item.orderDate);
        
      })
      let option;

      option = {
        xAxis: {
          type: 'category',
          data: time
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: arr,
            smooth:true,
            type: 'line',
            itemStyle:{
              color:'#587bf3'
            }
          }
        ],
         tooltip:{trigger:'axis',axisPointer:{type:'line'}}
      };

      option && this.orderChart.setOption(option);
    },
    initUserCharts(data = null){
      let chartDom = document.getElementById('userChart');
      this.userChart = echarts.init(chartDom);
      let arr = [];
      let time = [];
      let max = 0;
      data.forEach(item=>{
        arr.push(item.dailyNewUsers);
        time.push(item.registerDate);
        if(item.dailyNewUsers > max){
          max = item.dailyNewUsers;
        }
      })
      let option;

      option = {
        xAxis: {
          type: 'category',
          data: time
        },
        yAxis: {
          type: 'value',
          min:0,
          max:max,
          interval:1
        },
        series: [
          {
            data: arr,
            smooth:true,
            type: 'line',
            itemStyle:{
              color:'#587bf3'
            }
          }
        ],
         tooltip:{trigger:'axis',axisPointer:{type:'line'}}
      };

      option && this.userChart.setOption(option);
    }
  },
};
</script>

<style lang="scss" scoped>
.center{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashboard_warp {
  // background: #f7f7f7;
  height: calc(100vh - 144px);
  padding: 30px;
  overflow-y: auto;
  .user-top{
    width:100%;
    height:350px;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 12px;
    padding:12px;
    box-sizing: border-box;
    .order-top{
      width:100%;
      height:30px;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      .order-list{
        display: flex;
        flex-direction: column;
        height:100%;
        justify-content: space-between;
        align-items: center;
        margin-right:20px;
        .line{
          width:30px;
          height:2px;
          background: #587bf3;
        }
      }
    }
    .user-view{
      width:100%;
      height:300px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
